// reset-scroll-on-navigate.directive.ts
import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Directive({
  selector: '[resetScrollOnNavigate]',
  standalone: true,
})
export class ResetScrollOnNavigateDirective implements OnInit, OnDestroy {
  private sub?: Subscription;
  constructor(private el: ElementRef<HTMLElement>, private router: Router) {}
  ngOnInit() {
    this.sub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.el.nativeElement.scrollTo({ top: 0, left: 0, behavior: 'auto' }));
  }
  ngOnDestroy() { this.sub?.unsubscribe(); }
}
